import { useAuth } from "hooks/useAuth";
import { AuthProvider } from "./auth-context";

export const AuthGate = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-100 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">Loading...</h2>
                    <p className="text-gray-600">Please wait while we initialize the application...</p>
                </div>
            </div>
        );
    }

    return (
        <AuthProvider user={user}>
            {children}
        </AuthProvider>
    );
};
